/**
 * Mobile / desktop deep links for MetaMask and Rainbow.
 * Prefer native SDK (window.ethereum) when injected; fall back to these URIs.
 *
 * Deep links always point at a wallet-reachable https origin — preview,
 * localhost and http origins fall back to the canonical site origin, because
 * wallet in-app browsers cannot load them.
 */

import { dappUrlForRainbow, isMobileWalletBrowser, rainbowDeepLink } from "@/lib/rainbowDeepLink";

/** Path that opens the SphinxOS bridge console (mainnet zkEVM by default). */
export const BRIDGE_PATH = "/bridge?mode=mainnet";

export function dappAbsoluteUrl(path = BRIDGE_PATH): string {
  return dappUrlForRainbow(path);
}

/** MetaMask mobile deep link → open this dapp in-app browser. */
export function metamaskDappLink(path = BRIDGE_PATH): string {
  // metamask.app.link/dapp/<host><path> — no https:// in the host segment
  const url = new URL(dappAbsoluteUrl(path));
  return `https://metamask.app.link/dapp/${url.host}${url.pathname}${url.search}`;
}

/** Rainbow Wallet deep link → open dapp. */
export function rainbowDappLink(path = BRIDGE_PATH): string {
  return rainbowDeepLink(path, "web");
}

/** Rainbow alternate scheme used by some mobile clients. */
export function rainbowAppLink(path = BRIDGE_PATH): string {
  return rainbowDeepLink(path, "app");
}

export type WalletDeepLink = {
  id: "metamask" | "rainbow";
  label: string;
  href: string;
  hint: string;
};

export function bridgeWalletDeepLinks(path = BRIDGE_PATH): WalletDeepLink[] {
  const mobile = isMobileWalletBrowser();
  return [
    {
      id: "metamask",
      label: mobile ? "Open in MetaMask" : "Open in MetaMask browser",
      href: metamaskDappLink(path),
      hint: mobile ? "Mobile deep link · zkSync Era / zkEVM" : "Scan or open on mobile · zkSync Era / zkEVM",
    },
    {
      id: "rainbow",
      label: mobile ? "Open in Rainbow" : "Open in Rainbow browser",
      href: rainbowDappLink(path),
      hint: mobile ? "Mobile deep link · EIP-1193 wallet" : "Scan or open on mobile · EIP-1193 wallet",
    },
  ];
}
